module.exports = __webpack_public_path__ + "img/checked.c87ba8c8.png";